import Input from './input.vue'
export default (Vue) => {
  Vue.component('AbInput', Input)
}
